import { loadCsv } from '../../assets/js/util'

export default {
    namespaced: true,
    state: () => ({
        curtain_data : [],
        wall_data    : [],
        floor_data   : []
    }),
    mutations: {
        setCurtainData(state, data) { state.curtain_data = data },
        setWallData(state, data)    { state.wall_data    = data },
        setFloorData(state, data)   { state.floor_data   = data },
    },
    actions: {
        async loadItemData({commit}) {
            try{
                const csv_list = ['curtain.csv', 'wall.csv', 'floor.csv'];
                const await_list = csv_list.map( file_name => loadCsv(`./item_data/${file_name}`) );
                const [curtain_data, wall_data, floor_data] = await Promise.all(await_list);

                commit('setCurtainData', curtain_data);
                commit('setWallData', wall_data);
                commit('setFloorData', floor_data);

                return true;
            } catch {
                console.error('データの読み込みに失敗しました');
                return false;
            }
        }
    }
}
